<template lang="html">
  <div style="height: 100%;">
    <v-card class="mb-1 mt-2">
      <v-card-title>
        <v-row class="CategoriaTabela__Toolbar" align="center" no-gutters>
          <v-col cols="12" md="4" class="pr-md-3">
            <h3 class="headline mb-0">{{ titlePage }}</h3>
          </v-col>
          <v-col cols="12" sm="4" md="3" class="pr-sm-3 mt-3 mt-md-0">
            <v-text-field
              dense
              clearable
              hide-details
              outlined
              append-icon="search"
              :label="$t('label.pesquisar')"
              v-model="search"
              @input="filtrar"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="4" md="2" class="pr-sm-3 mt-3 mt-md-0">
            <v-select
              dense
              outlined
              hide-details
              :items="opcoesStatus"
              item-text="text"
              item-value="value"
              label="STATUS"
              v-model="filtroStatus"
              @change="filtrar"
            ></v-select>
          </v-col>
          <v-col cols="12" sm="4" md="3" class="mt-3 mt-md-0">
            <v-select
              dense
              outlined
              hide-details
              :items="opcoesProvisionada"
              item-text="text"
              item-value="value"
              label="PROVISIONADA"
              v-model="filtroProvisionada"
              @change="filtrar"
            ></v-select>
          </v-col>
        </v-row>
      </v-card-title>
      <tree-list v-if="mostrarTreeList"
        :disabled="somenteLeitura"
        :data-source="categorias"
        ref="treeList"
        coluna-chave="id"
        :search-panel="false"
        :cache-enabled="false"
        coluna-tem-item="tem_item"
        coluna-chave-pai="idPai"
        :colunas="colunas">
      </tree-list>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Confirm from '@/shared-components/dialog/Confirm';
import TreeList from '@/shared-components/treeList/TreeList';

export default {
  name: 'CategoriaTabela',
  components: {
    Confirm,
    TreeList,
  },
  props: {
    somenteLeitura: {
      type: Boolean,
      default: false,
    },
    titlePage: String,
    idNivelExtensao: {
      type: Number,
      default: 2,
    },
  },
  data() {
    return {
      mostrarTreeList: true,
      categorias: [],
      todasCategorias: [],
      esperar: false,
      headers: [
        {
          text: '', value: 'acoes', sortable: false, align: 'center',
        },
        { text: this.$tc('label.codigo', 1), value: 'id_externo' },
        { text: this.$tc('label.descricao', 1), value: 'nom_extensao' },
        { text: this.$tc('label.ativo', 1), value: 'ind_ativo' },
        { text: this.$tc('label.descricao_oracle', 1), value: 'nom_extensao_oracle' },
      ],
      nivelProdutoResources: this.$api.nivelProduto(this.$resource),
      totalPage: 0,
      search: '',
      filtroStatus: 'TODOS',
      filtroProvisionada: 'TODOS',
      opcoesStatus: [
        { text: this.$tc('label.todos', 1), value: 'TODOS' },
        { text: this.$tc('label.ativo', 1), value: 'ATIVO' },
        { text: this.$tc('label.inativo', 1), value: 'INATIVO' },
      ],
      opcoesProvisionada: [
        { text: this.$tc('label.todos', 1), value: 'TODOS' },
        { text: this.$tc('label.sim', 1), value: 'SIM' },
        { text: this.$tc('label.nao', 1), value: 'NAO' },
      ],
    };
  },
  computed: {
    ...mapGetters('roles', [
      'getAllRoles',
      'getTenantId',
    ]),
    colunasBase() {
      return [
        {
          dataField: '',
          caption: '',
          cellTemplate: (element, info) => {
            if (!this.somenteLeitura) {
              element.append('<button type="button" style="margin: 0px 0px 0px 15px; padding: 0px; height: auto; min-height: auto" '
                .concat('class="md-button md-icon-button md-theme-default" onclick="TreeView_editPorId(')
                .concat(info.data.id)
                .concat(')"><i aria-hidden="true" class="v-icon material-icons">edit</i>'
                  .concat('</button>')));
            }
          },
        },
        {
          dataField: 'idExterno',
          caption: this.$tc('label.codigo', 1),
          minWidth: 300,
          cellTemplate: (element, info) => {
            const valor = info.data.idExterno || info.data.idexterno || '';
            element.append(valor);
          },
        },
        {
          dataField: 'nomExtensao',
          caption: this.$tc('label.descricao', 1),
          cellTemplate: (element, info) => {
            const valor = info.data.nomExtensao || info.data.nomextensao || '';
            element.append(valor);
          },
        },
        {
          dataField: 'indAtivo',
          caption: this.$tc('label.ativo', 1),
          cellTemplate: (element, info) => {
            const valor = info.data.indAtivo !== undefined ? info.data.indAtivo : info.data.indativo;
            if (valor) {
              element.append(this.$tc('label.sim', 1));
            } else {
              element.append(this.$tc('label.nao', 1));
            }
          },
        },
        {
          dataField: 'nomExtensaoOracle',
          caption: this.$tc('label.descricao_oracle', 1),
          cellTemplate: (element, info) => {
            element.append(this.obterDescricaoOracle(info.data));
          },
        },
      ];
    },
    isTenantEpoca() {
      return this.getTenantId === 'epoca';
    },
    canVisualizarDescricaoOracle() {
      return this.possuiRole('ROLE_CATEGORIA_AUDITORIA_VISUALIZAR')
        || this.possuiRole('ROLE_CATEGORIA_AUDITORIA_ALTERAR');
    },
    colunas() {
      return this.colunasBase.filter((coluna) => coluna.dataField !== 'nomExtensaoOracle'
        || this.canVisualizarDescricaoOracle);
    },
  },
  methods: {
    possuiRole(role) {
      return !!(this.getAllRoles && this.getAllRoles.includes(role));
    },
    obterDescricaoOracle(infoData) {
      if (!infoData) {
        return '';
      }
      return infoData.nomExtensaoOracle || infoData.nomextensaooracle || '';
    },
    possuiStatusAtivo(item) {
      const statusValor = item.status || (item.desAtributos ? item.desAtributos.status : null);

      if (statusValor) {
        return String(statusValor).toUpperCase() === 'ATIVO';
      }

      const indAtivo = item.indAtivo !== undefined ? item.indAtivo : item.indativo;
      return !!indAtivo;
    },
    possuiProvisionada(item) {
      let provisionada = false;

      if (item.indProvisionada !== undefined) {
        provisionada = item.indProvisionada;
      } else if (item.desAtributos && item.desAtributos.indProvisionada !== undefined) {
        provisionada = item.desAtributos.indProvisionada;
      }

      if (typeof provisionada === 'boolean') {
        return provisionada;
      }

      if (typeof provisionada === 'string') {
        const valorNormalizado = provisionada.toLowerCase();
        return valorNormalizado === 'true' || valorNormalizado === 'sim';
      }

      return false;
    },
    aplicarFiltrosRapidos() {
      let categoriasFiltradas = [...this.todasCategorias];

      if (this.filtroStatus === 'ATIVO') {
        categoriasFiltradas = categoriasFiltradas.filter((item) => this.possuiStatusAtivo(item));
      } else if (this.filtroStatus === 'INATIVO') {
        categoriasFiltradas = categoriasFiltradas.filter((item) => !this.possuiStatusAtivo(item));
      }

      if (this.filtroProvisionada === 'SIM') {
        categoriasFiltradas = categoriasFiltradas.filter((item) => this.possuiProvisionada(item));
      } else if (this.filtroProvisionada === 'NAO') {
        categoriasFiltradas = categoriasFiltradas.filter((item) => !this.possuiProvisionada(item));
      }

      this.categorias = categoriasFiltradas;
      this.recarregar();
      this.pararEsperar();
    },
    buscar() {
      const params = {
        nome: this.search || '',
        idNivelExtensao: this.idNivelExtensao,
      };

      this.nivelProdutoResources.categorias(params).then((response) => {
        this.categorias = response.data.resposta;
        const filhos = [];
        this.categorias.forEach((categoria) => {
          categoria.filhos = categoria.filhos
            ? JSON.parse(categoria.filhos.value) : [];
          categoria.filhos.forEach((filho) => {
            filhos.push(filho);
          });
        });

        this.todasCategorias = this.categorias.concat(filhos);
        this.aplicarFiltrosRapidos();
      }, (err) => {
        this.pararEsperar();
        this.$error(this, err);
      });
    },
    editItem(item) {
      this.$emit('edit', item);
    },
    editPorId(id) {
      const item = this.categorias.filter((categoria) => categoria.id === id)[0];
      this.editItem(item);
    },
    filtrar() {
      if (this.esperar) return;
      this.esperar = true;
      setTimeout(() => {
        if (!this.isTenantEpoca) {
          this.buscar();
        }
      }, 1000);
    },
    pararEsperar() {
      setTimeout(() => {
        this.esperar = false;
      }, 2E2);
    },
    recarregar() {
      this.mostrarTreeList = false;
      setTimeout(() => {
        this.mostrarTreeList = true;
      });
    },
  },
  mounted() {
    this.filtrar();
    window.TreeView_editPorId = this.editPorId; // eslint-disable-line
  },
};
</script>
<style>
  .icon-size {
    font-size: 17px;
  }
  .dx-pager .dx-page,
  .dx-pager .dx-page-size {
    font-size: 12px;
    -webkit-border-radius: 0px;
    -moz-border-radius: 0px;
    -ms-border-radius: 0px;
    -o-border-radius: 0px;
    border-radius: 0px;
  }
  .dx-pager .dx-pages .dx-selection,
  .dx-pager .dx-page-sizes .dx-selection {
    font-weight: 500;
    background-color: #777;
    color: #fff;
  }
</style>
